import { useEffect, useRef } from "react";
import Menu from "./Menu.jsx";
import { BrowserRouter as Router } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import Dash from "../comun/Dash.jsx";
import Proyectos from "./Proyectos.jsx";
import Seguimiento from "./Seguimiento.jsx";
import Historico from "./Historico.jsx";
import CambiarFoto from "../comun/CambiarFoto.jsx";

import Foro from "../comun/Foro.jsx";
import Chat from "../comun/Chat.jsx";
import SalaStreaming from "./SalaStreaming.jsx";
import Analitica from "./Analitica.jsx";
import Alertas from "./Alertas.jsx";
import ForoTemas from "../comun/ForoTemas.jsx";
import PlantillaSencilla from "../comun/PlantillaSencilla.jsx";
import AportantesLogo from "./AportantesLogo.jsx";
import NotFound from "../comun/NotFound.jsx";

const Index = (props) => {
  const testRef = useRef(null);
  const scrollToElement = () => testRef.current.scrollIntoView();

  useEffect(() => {
    scrollToElement();
  }, [props]);

  return (
    <Router>
      <div className="container-fluid" ref={testRef}>
        <div className="row">
          <div className="col-sm-2">
            <Menu
              Id={props.perfil.Id}
              Nbres={props.perfil.Nbres}
              Foto={props.perfil.Foto}
              Socket={props.socket}
              cerrarSesion={props.cerrarSesion}
            />
          </div>
          <div className="col-sm-10">
            <Routes>
              <Route
                path="/foto"
                element={
                  <CambiarFoto
                    Ruta={"fotos"}
                    Tabla={"usuarios"}
                    Campo={"Foto"}
                    Id={props.perfil.Id}
                    Foto={props.perfil.Foto}
                    actualizarCampoPerfil={props.actualizarCampoPerfil}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route path="/dash" element={<Dash />} />
              <Route
                path="/proyectos"
                element={
                  <Proyectos
                    perfil={props.perfil}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route
                path="/seguimiento"
                element={
                  <Seguimiento
                    idUsuario={props.perfil.Id}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route path="/historico" element={<Historico />} />
              <Route
                path="/chat"
                element={
                  <Chat
                    idUsuario={props.perfil.Id}
                    nbres={props.perfil.Nbres}
                    tipoParticipante={props.perfil.TipoParticipante}
                    socket={props.socket}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route
                path="/foro"
                element={
                  <Foro
                    idUsuario={props.perfil.Id}
                    idProyecto={props.perfil.IdProyecto}
                    mostrarMsg={props.mostrarMsg}
                    tipoParticipante={props.perfil.TipoParticipante}
                  />
                }
              />
              <Route
                path="/sala"
                element={
                  <SalaStreaming
                    idUsuario={props.perfil.Id}
                    nbres={props.perfil.Nbres}
                    tipoParticipante={props.perfil.TipoParticipante}
                    socket={props.socket}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route path="/analitica" element={<Analitica />} />
              <Route path="/alertas" element={<Alertas />} />
              <Route
                path="/cargos"
                element={
                  <PlantillaSencilla
                    idUsuario={props.perfil.Id}
                    tabla={"cargos"}
                    titulo={"CARGOS"}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route
                path="/aportantes"
                element={
                  <AportantesLogo
                    idUsuario={props.perfil.Id}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route
                path="/foroTemas"
                element={
                  <ForoTemas
                    idUsuario={props.perfil.Id}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />

              <Route
                path="/familiaridad"
                element={
                  <PlantillaSencilla
                    idUsuario={props.perfil.Id}
                    tabla={"familiaridad"}
                    titulo={"TIPO DE FAMILIAR"}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route
                path="/poblacion"
                element={
                  <PlantillaSencilla
                    idUsuario={props.perfil.Id}
                    tabla={"poblacion"}
                    titulo={"TIPOS DE POBLACION"}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />

              <Route
                path="/tipodocumento"
                element={
                  <PlantillaSencilla
                    idUsuario={props.perfil.Id}
                    tabla={"tipo_documento"}
                    titulo={"TIPOS DE DOCUMENTOS"}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
};

export default Index;
